import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_BASE_URL } from 'core/constants/general'
import { updateToken } from 'keycloak'

const baseQueryWithAuth = async (args: any, api: any, extraOptions: any) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers) => {
      const token = await updateToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  })

  return baseQuery(args, api, extraOptions)
}

export const baseApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'Client',
    'Application',
    'Prompt',
    'Tag',
    'TagsWithApps',
    'Conversation',
    'KeycloakUser',
    'Utilisateur',
  ],
  endpoints: () => ({}),
  keepUnusedDataFor: 5,
})
